/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_Total_EnergyInputs */

const en_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`World Total Energy`)
};

const ar_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي القوة العالمية`)
};

const de_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weltweite Gesamt-Power`)
};

const es_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poder total mundial`)
};

const fr_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouvoir total mondial`)
};

const it_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power totale mondiale`)
};

const ja_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全世界累計パワー`)
};

const ko_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세계 총 Power`)
};

const pt_br_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poder Total Mundial`)
};

const ru_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая мировая сила`)
};

const th_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พลังรวมทั่วโลก`)
};

const tr_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünya Toplam Gücü`)
};

const zh_cn_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前全球累计能量`)
};

const zh_tw_current_total_energy = /** @type {(inputs: Current_Total_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前全球累計能量`)
};

/**
* | output |
* | --- |
* | "World Total Energy" |
*
* @param {Current_Total_EnergyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const current_total_energy = /** @type {((inputs?: Current_Total_EnergyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_Total_EnergyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_total_energy(inputs)
	if (locale === "ar") return ar_current_total_energy(inputs)
	if (locale === "de") return de_current_total_energy(inputs)
	if (locale === "es") return es_current_total_energy(inputs)
	if (locale === "fr") return fr_current_total_energy(inputs)
	if (locale === "it") return it_current_total_energy(inputs)
	if (locale === "ja") return ja_current_total_energy(inputs)
	if (locale === "ko") return ko_current_total_energy(inputs)
	if (locale === "pt_br") return pt_br_current_total_energy(inputs)
	if (locale === "ru") return ru_current_total_energy(inputs)
	if (locale === "th") return th_current_total_energy(inputs)
	if (locale === "tr") return tr_current_total_energy(inputs)
	if (locale === "zh_cn") return zh_cn_current_total_energy(inputs)
	return zh_tw_current_total_energy(inputs)
});